import React from "react";
import { Link, useSearchParams } from "react-router-dom";

import MarketingFooter from "../components/marketing/MarketingFooter";
import MarketingSiteHeader from "../components/marketing/MarketingSiteHeader";
import { JOIN_PORTFOLIO } from "../data/platformPresentation";

import "../marketing-join-portfolio.css";

export default function WebsiteSignupPage() {
  const [searchParams] = useSearchParams();
  const referral = (searchParams.get("ref") || searchParams.get("camp") || "").trim();
  const signupPath = referral ? `/signup?${searchParams.toString()}` : "/signup";

  const scrollTo = (id) => {
    if (id) {
      window.location.href = `/#${id}`;
    }
  };

  return (
    <div className="nh-rh nh-join-page">
      <MarketingSiteHeader />

      <main className="nh-join">
        <div className="nh-join__inner">
          <h1 className="nh-join__title">{JOIN_PORTFOLIO.title}</h1>
          <p className="nh-join__lead">{JOIN_PORTFOLIO.lead}</p>
          <p className="nh-join__sub">{JOIN_PORTFOLIO.sub}</p>

          {referral ? (
            <p className="nh-join__referral" role="status">
              Referral or campaign link detected — your code will be applied during registration.
            </p>
          ) : null}

          <Link to={signupPath} className="nh-join__cta">
            {JOIN_PORTFOLIO.cta}
          </Link>
          <p className="nh-join__signin">
            <Link to="/login">{JOIN_PORTFOLIO.signInCta}</Link>
          </p>
        </div>
      </main>

      <section className="nh-join__newsletter">
        <div className="nh-join__newsletter-inner">
          <h2 className="nh-join__newsletter-title">{JOIN_PORTFOLIO.newsletterTitle}</h2>
          <Link to="/" className="nh-join__newsletter-archive">
            {JOIN_PORTFOLIO.newsletterArchive} →
          </Link>
        </div>
      </section>

      <MarketingFooter onSectionScroll={scrollTo} />
    </div>
  );
}
